export const FORMAT_1 = { name: 'UTC−12:00, Y', value: '−12:00' };
export const FORMAT_2 = { name: 'UTC−11:00, X', value: '−11:00' };
export const FORMAT_3 = { name: 'UTC−10:00, W', value: '−10:00' };
export const FORMAT_4 = { name: 'UTC−09:30, V†', value: '−09:30' };
export const FORMAT_5 = { name: 'UTC−09:00, V', value: '−09:00' };
export const FORMAT_6 = { name: 'UTC−08:00, U', value: '−08:00' };
export const FORMAT_7 = { name: 'UTC−07:00, T', value: '−07:00' };
export const FORMAT_8 = { name: 'UTC−06:00, S', value: '−06:00' };
export const FORMAT_9 = { name: 'UTC−05:00, R', value: '−05:00' };
export const FORMAT_10 = { name: 'UTC−04:00, Q', value: '−04:00' };
export const FORMAT_11 = { name: 'UTC−03:30, P†', value: '−03:30' };
export const FORMAT_12 = { name: 'UTC−03:00, P', value: '−03:00' };
export const FORMAT_13 = { name: 'UTC−02:00, O', value: '−02:00' };
export const FORMAT_14 = { name: 'UTC−01:00, N', value: '−01:00' };
export const FORMAT_15 = { name: 'UTC±00:00, Z', value: '±00:00' };
export const FORMAT_16 = { name: 'UTC+01:00, A', value: '+01:00' };
export const FORMAT_17 = { name: 'UTC+02:00, B', value: '+02:00' };
export const FORMAT_18 = { name: 'UTC+03:00, C', value: '+03:00' };
export const FORMAT_19 = { name: 'UTC+04:00, D', value: '+04:00' };
export const FORMAT_20 = { name: 'UTC+04:30, D†', value: '+04:30' };
export const FORMAT_21 = { name: 'UTC+05:00, E', value: '+05:00' };
export const FORMAT_22 = { name: 'UTC+05:30, E†', value: '+05:30' };
export const FORMAT_23 = { name: 'UTC+05:45, E*', value: '+05:45' };
export const FORMAT_24 = { name: 'UTC+06:00, F', value: '+06:00' };
export const FORMAT_25 = { name: 'UTC+06:30, F†', value: '+06:30' };
export const FORMAT_26 = { name: 'UTC+07:00, G', value: '+07:00' };
export const FORMAT_27 = { name: 'UTC+08:00, H', value: '+08:00' };
export const FORMAT_28 = { name: 'UTC+08:30, H†', value: '+08:30' };
export const FORMAT_29 = { name: 'UTC+08:45, H*', value: '+08:45' };
export const FORMAT_30 = { name: 'UTC+09:00, I', value: '+09:00' };
export const FORMAT_31 = { name: 'UTC+09:30, I†', value: '+09:30' };
export const FORMAT_32 = { name: 'UTC+10:00, K', value: '+10:00' };
export const FORMAT_33 = { name: 'UTC+10:30, K†', value: '+10:30' };
export const FORMAT_34 = { name: 'UTC+11:00, L', value: '+11:00' };
export const FORMAT_35 = { name: 'UTC+12:00, M', value: '+12:00' };
export const FORMAT_36 = { name: 'UTC+12:45, M*', value: '+12:45' };
export const FORMAT_37 = { name: 'UTC+13:00, M†', value: '+13:00' };
export const FORMAT_38 = { name: 'UTC+14:00, M†', value: '+14:00' };

const Basic = [
  FORMAT_1,
  FORMAT_2,
  FORMAT_3,
  FORMAT_4,
  FORMAT_5,
  FORMAT_6,
  FORMAT_7,
  FORMAT_8,
  FORMAT_9,
  FORMAT_10,
  FORMAT_11,
  FORMAT_12,
  FORMAT_13,
  FORMAT_14,
  FORMAT_15,
  FORMAT_16,
  FORMAT_17,
  FORMAT_18,
  FORMAT_19,
  FORMAT_20,
  FORMAT_21,
  FORMAT_22,
  FORMAT_23,
  FORMAT_24,
  FORMAT_25,
  FORMAT_26,
  FORMAT_27,
  FORMAT_28,
  FORMAT_29,
  FORMAT_30,
  FORMAT_31,
  FORMAT_32,
  FORMAT_33,
  FORMAT_34,
  FORMAT_35,
  FORMAT_36,
  FORMAT_37,
  FORMAT_38,
];

const BasicByValue = Basic.reduce((hash, format) => {
  hash[format.value] = format;
  return hash;
}, {});

export default { Basic, BasicByValue };
